import { AzureLocale } from './auth/authContext'

const defaultAzureLocales = { locale: 'en-GB', ui_locales: 'en' }

const azureLocales: Record<string, AzureLocale> = {
  en: { locale: 'en-GB', ui_locales: 'en' },
  no: { locale: 'nb-NO', ui_locales: 'nb-NO' },
  nb: { locale: 'nb-NO', ui_locales: 'nb-NO' },
  pt: { locale: 'pt-PT', ui_locales: 'pt-PT' },
  de: { locale: 'de-DE', ui_locales: 'de' },
  fr: { locale: 'fr-FR', ui_locales: 'fr' },
  da: { locale: 'da-DK', ui_locales: 'da' },
  sv: { locale: 'sv-SE', ui_locales: 'sv' },
}

export const getAzureLocales = (language?: string): AzureLocale =>
  azureLocales[language?.split(/[-_]/)[0]?.toLowerCase()] ?? defaultAzureLocales
